module.exports = __webpack_public_path__ + "fonts/Montserrat-Black.22fd37d1.woff2";